<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0"
        y="0"
        viewBox="0 0 65 65"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <circle cx="32.5" cy="32.5" r="32" fill="#ff9f0d" opacity="1" data-original="#ff9f0d" class=""></circle>
            <g fill="#fff">
                <path
                    d="M30.1 9h4.8v15h-4.8zM30.1 41h4.8v15h-4.8zM41 30.1h15v4.8H41zM9 30.1h15v4.8H9zM36.895 24.753 47.5 14.148l3.394 3.393-10.605 10.605zM14.164 47.395 24.769 36.79l3.393 3.394-10.605 10.605zM36.85 40.296l3.393-3.394 10.605 10.605-3.393 3.394z"
                    fill="#ffffff"
                    opacity="1"
                    data-original="#ffffff"></path>
            </g>
        </g>
    </svg>
</template>
